import { LeftCol } from "./ProfileComponents/leftCol";
import {
  Avatar,
  Card,
  Col,
  Divider,
  Icon,
  Input,
  Row,
  Tag,
  message,
  Statistic,
  Layout,
  Skeleton
} from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import * as loginActions from "./actions";
import { Link } from "react-router-dom";
import HackerEarth from "./Components/HackerEarth/hackerEarth";
import GeeksForGeeks from "./Components/GeeksForGeeks/geeksForGeeks";
import HackerRank from "./Components/HackerRank/hackerRank";
import CodeChef from "./Components/CodChef/codeChef";
import GithubProfile from "./Components/Github/githubProfile";
import StepThree from "../overview/form/stepThree/step3";
import StepFour from "../overview/form/stepFour/step4";
import StepFive from "../overview/form/stepFive/step5";
import StepSix from "../overview/form/stepSix/step6";
import StepSeven from "../overview/form/stepSeven/step7";
import StepEight from "../overview/form/stepEight/step8";
import StepNine from "../overview/form/stepNine/step9";

import styles from "./center.module.less";
import "./profile.css";
import { ProjectList } from "./ProfileComponents/tabComponents/projectList";
import { CertificationList } from "./ProfileComponents/tabComponents/certificationList";
import { ConferencesList } from "./ProfileComponents/tabComponents/conferenceList";
import { ResearchList } from "./ProfileComponents/tabComponents/researchList";
import { WorkhopList } from "./ProfileComponents/tabComponents/workhopList";
import { TechnicalSkillsList } from "./ProfileComponents/tabComponents/technicalSkillsList";
import { InternshipsList } from "./ProfileComponents/tabComponents/internshipsList";
import { HackathonList } from "./ProfileComponents/tabComponents/hackathonList";
import { AchievementList } from "./ProfileComponents/tabComponents/achievementList";



const operationTabList = [
  {
    key: "hackerRank",
    tab: (
      <span>
        <img
          style={{ width: 20, height: 20 }}
          src="https://www.hackerrank.com/wp-content/uploads/2018/07/hackerrank-favicon.png"
        ></img>{" "}
        HackerRank
      </span>
    )
  },
  {
    key: "hackerEarth",
    tab: (
      <span>
        <img
          style={{ width: 20, height: 20 }}
          src="https://static-fastly.hackerearth.com/static/hackerearth/images/logo/HE_identity.png"
        ></img>{" "}
        HackerEarth
      </span>
    )
  },
  {
    key: "geeksForGeeks",
    tab: (
      <span>
        <img
          style={{ width: 20, height: 20 }}
          src="https://www.geeksforgeeks.org/favicon.ico"
        ></img>
        GeeksForGeeks
      </span>
    )
  },{
    key: "codeChef",
    tab: (
      <span>
        <img
          style={{ width: 20, height: 20 }}
          src="https://s3.amazonaws.com/codechef_shared/misc/favicon.ico"
        ></img>{" "}
        CodeChef
      </span>
    )
  },
];
export const projectsTabList = [
  {
    key: "github",
    tab: (
      <span>
        <Icon type="github" /> Github Profile
       
      </span>
    )
  },
  {
    key: "projects",
    tab: (
      <span>
        <Icon type="code-sandbox" /> Projects
        
      </span>
    )
  },
  {
    key: "skills",
    tab: (
      <span>
        <Icon type="bulb" />
        Skills
       
      </span>
    )
  },
  {
    key: "hackathons",
    tab: (
      <span>
        <Icon type="codepen" />
        Hackathons
       
      </span>
    )
  },
  {
    key: "achievements",
    tab: (
      <span>
       <Icon type="sketch" />
        Achievements
      </span>
    )
  }
];
export const workshopsTabList = [
  {
    key: "workshops",
    tab: (
      <span>
        <Icon type="code" /> Workshops
       
      </span>
    )
  },
  {
    key: "certificates",
    tab: (
      <span>
        <Icon type="book" /> Certificates
       
      </span>
    )
  },
  {
    key: "internships",
    tab: (
      <span>
        <Icon type="api" /> Internships
        
      </span>
    )
  },
  {
    key: "conferences",
    tab: (
      <span>
        <Icon type="contacts" />
        Conferences
       
      </span>
    )
  },
  {
    key: "research",
    tab: (
      <span>
        <Icon type="read" />
        Research Papers
       
      </span>
    )
  }
];

class Profile extends Component {
  constructor(props) {
    super(props);
    
    const { uid } = props.match.params;
    this.state = {
      loading: true,
      currentUser: uid,
      newTags: [],
      inputVisible: false,
      inputValue: "",
      cptabKey: "hackerRank",
      // cptabKey: "geeksForGeeks",
      prtabKey: "github",
      wstabKey: "workshops",
      error: false,
      redirectURL: "/"
    };
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  componentWillMount() {
    
    if (
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.uid &&
      this.props.match.params.uid.length > 0
    ) {
      this.props.loadUserProfileData(this.props.match.params.uid);
    }
  }

  renderChildrenByTabKey = tabKey => {
    if (tabKey === "hackerEarth") {
      if (
        this.props.programmingWebsitesProfiles &&
        this.props.programmingWebsitesProfiles.HackerEarth
      ) {
        const uid = this.props.programmingWebsitesProfiles.HackerEarth.userName

        if (uid)
          return (
            <HackerEarth
              userName={uid}
              uid={this.props.userProfile.UID}
            />
          );
      }
      return (
        <div style={{ textAlign: "center" }}>
          User has not linked his HackerEarth profile
        </div>
      );
    }

    if (tabKey === "geeksForGeeks") {
      if (
        this.props.programmingWebsitesProfiles &&
        this.props.programmingWebsitesProfiles.GeeksForGeeks
      ) {
        const uid = this.props.programmingWebsitesProfiles.GeeksForGeeks.userName

        if (uid)
          return (
            <GeeksForGeeks
              userName={uid}
              uid={this.props.userProfile.UID}
            />
          );
      }
      return (
        <div style={{ textAlign: "center" }}>
          User has not linked his GeeksforGeeks profile
        </div>
      );
    }
    if (tabKey === "hackerRank") {
      if (
        this.props.programmingWebsitesProfiles &&
        this.props.programmingWebsitesProfiles.HackerRank
      ) {
        const uid = this.props.programmingWebsitesProfiles.HackerRank.userName

        if (uid)
          return (
            <HackerRank
              userName={uid}
              uid={this.props.userProfile.UID}
            />
          );
      }
      return (
        <div style={{ textAlign: "center" }}>
          User has not linked his HackerRank profile
        </div>
      );
    }
    if (tabKey === "codeChef") {
      if (
        this.props.programmingWebsitesProfiles &&
        this.props.programmingWebsitesProfiles.CodeChef
      ) {
        const uid = this.props.programmingWebsitesProfiles.CodeChef.userName

        if (uid)
          return (
          <div style={{ textAlign: "center" }}>
            CodeChef data is unavailable at the moment. Try again later
          </div>
            // <CodeChef
            //   userName={uid}
            //   uid={this.props.userProfile.UID}
            // />
          );
      }
      return (
        <div style={{ textAlign: "center" }}>
          User has not linked his codeChef profile
        </div>
      );
    }

    if (tabKey === "github") {
      
      if (
        this.props.programmingWebsitesProfiles  && this.props.programmingWebsitesProfiles.Github
      ) {
        return <GithubProfile userName={this.props.programmingWebsitesProfiles.Github.userName} />;
      }
      return (
        <div style={{ textAlign: "center" }}>
          User has not linked his Github profile
        </div>
      );
    }

    // if (tabKey === "projects") {
    //   if (this.props.auth.uid === this.props.match.params.uid) {
    //     return (
    //       <StepFour
    //         showDiscription={true}
    //         showAddNew={this.props.auth.uid === this.props.match.params.uid}
    //       />
    //     );
    //   } else {
    //     return (
    //       <ProjectList
    //         technicalSkills={this.props.userProfile.projectsDoneList}
    //       />
    //     );
    //   }
    // }

    if (tabKey === "projects") {
        return (
          <ProjectList
            technicalSkills={this.props.userProfile.projectsDoneList}
          />
        );
    }
    if (tabKey === "skills") {
        return (
          <TechnicalSkillsList
            technicalSkills={this.props.userProfile.technicalSkills}
          />
        );
    }

    if (tabKey === "research") {
    
        return (
          <ResearchList
            technicalSkills={this.props.userProfile.pubications}
          />
        );
    }
    if (tabKey === "internships") {
     
        return (
          <InternshipsList
            technicalSkills={this.props.userProfile.InternshipAttended}
          />
        );
    }
    if (tabKey === "workshops") {
     
        return (
          <WorkhopList
            technicalSkills={this.props.userProfile.workshopsAttended}
          />
        );
    }
    if (tabKey === "hackathons") {
   
      return (
        <HackathonList
          technicalSkills={this.props.userProfile.hackathon}
        />
      );
  }

  if (tabKey === "achievements") {

    return (
      <AchievementList
        technicalSkills={this.props.userProfile.achievement}
      />
    );
}
    if (tabKey === "conferences") {
     
        return (
          <ConferencesList
            technicalSkills={this.props.userProfile.conferenceAttended}
          />
        );

    }
    if (tabKey === "certificates") {
      
        return (
          <CertificationList
            technicalSkills={this.props.userProfile.certification}
          />
        );

    }
  
    return null;
  };

  onTabChangeCP = key => {
    this.setState({
      cptabKey: key
    });
  };

  onTabChangePR = key => {
    this.setState({
      prtabKey: key
    });
  };

  onTabChangeWS = key => {
    this.setState({
      wstabKey: key
    });
  };

  render() {
    const loading = this.props.skeltonLoading
      ? this.props.skeltonLoading.show
      : true;
    const profiledata =
      this.props.userProfile &&
      Object.entries(this.props.userProfile).length != 0 &&
      this.props.userProfile.constructor === Object
        ? this.props.userProfile
        : null;
    
    const { cptabKey, prtabKey, wstabKey } = this.state;

    return (
      <div>
        <Skeleton active={loading} loading={loading}>
          {profiledata ? (
            <>
              <div style={{ margin: 24, paddingTop: 0 }}>
                <Row gutter={24}>
                  <LeftCol showEdit={this.props.auth.uid === this.props.match.params.uid} loading={loading} profiledata={profiledata} />

                  <Col lg={17} md={24}>
              
             {profiledata.role && profiledata.role=='STUDENT' && 
             <>
              <h1>Acadamic Details</h1>
              <Row
                style={{ marginBottom: 20, marginTop: 20 }}
                gutter={16}
              >
                <Col xs={24} sm={24} md={8} lg={6} xl={6}  style={{marginBottom:5}}>
                  <Card bordered={true}>
                    <Statistic
                      title="Campus"
                      value={profiledata.campus ? profiledata.campus: 'NA'}
                    />
                  </Card>
                </Col>
                <Col xs={24} sm={24} md={8} lg={6} xl={6}  style={{marginBottom:5}}>
                  <Card bordered={true}>
                    <Statistic
                    decimalSeparator=" "
                      title="Batch"
                      value={profiledata.gradYear ? (profiledata.gradYear).toString()+" ": 'NA'}
                    />
                  </Card>
                </Col>
                <Col xs={24} sm={24} md={8} lg={6} xl={6}  style={{marginBottom:5}}>
                  <Card bordered={true}>
                    <Statistic title="Department" value={profiledata.branch ? profiledata.branch: 'NA'} />
                  </Card>
                </Col>
                <Col xs={24} sm={24} md={8} lg={6} xl={6}  style={{marginBottom:5}}>
                  <Card bordered={true}>
                    <Statistic title="Section" value={profiledata.section ? profiledata.section: 'NA'} />
                  </Card>
                </Col>
              </Row>

              <h1>Acadamic Performance</h1>
              <Row
                style={{ marginBottom: 20, marginTop: 20 }}
                gutter={16}
              >
                <Col xs={24} sm={24} md={10} lg={8} xl={8} style={{marginBottom:5}}>
                  <Card bordered={true}>
                  <Col span={12}>
                  <Statistic
                      title="CGPA"
                      value={profiledata.cgpa ? (profiledata.cgpa).toString()+" ": 'NA'}
                    />
                  </Col>
                  <Col span={12}>
                  <Statistic
                      title="SGPA"
                      value={profiledata.sgpa ? (profiledata.sgpa).toString()+" ": 'NA'}
                    />
                  </Col>
                  </Card>
                </Col>
                <Col xs={24} sm={24} md={10} lg={8} xl={8}  style={{marginBottom:5}}>
                  <Card bordered={true}>
                  <Col span={12}>
                  <Statistic
                      title="Backlogs History"
                      value={profiledata.backlogshistory ? (profiledata.backlogshistory).toString()+" ": 'NA'}
                  />
                  </Col>
                  <Col span={12}  style={{marginBottom:5}}>
                  <Statistic
                      title="Current Backlogs"
                      value={profiledata.backlogs ? (profiledata.backlogs).toString()+" ": 'NA'}
                    />
                  </Col>
                  </Card>
                </Col>
                <Col xs={24} sm={24} md={10} lg={8} xl={8}>
                  <Card bordered={true}>
                  <Col span={12}>
                  <Statistic
                      title="10th"
                      value={profiledata.tenthgpa ? (profiledata.tenthgpa).toString()+" ": 'NA'}
                    />
                  </Col>
                  <Col span={12}>
                  <Statistic
                      title="12th"
                      value={profiledata.intergpa ? (profiledata.intergpa).toString()+" ": 'NA'}
                    />
                  </Col>
                  </Card>
                </Col>
              </Row>

              <h1>Resume</h1>
              <Row
                style={{ marginBottom: 20, marginTop: 20 }}
                gutter={16}
              >
                <Col span={24} style={{marginBottom:5}}>
                <Card bordered={true}>
                <Icon type="file-pdf" /> &nbsp; Not available
                </Card>
               </Col>
              </Row>
              </>
             }       
                 
                    <h1>Competitive programming</h1>
                    <Row
                      style={{ marginBottom: 20, marginTop: 20 }}
                      gutter={16}
                    >
                      <Col xs={24} sm={24} md={10} lg={8} xl={8} style={{marginBottom:5}}>
                        <Card bordered={false}>
                          <Statistic
                            title="Score in Data Structures"
                            value={"NA"}
                          />
                        </Card>
                      </Col>
                      <Col xs={24} sm={24} md={10} lg={8} xl={8} style={{marginBottom:5}}>
                        <Card bordered={false}>
                          <Statistic
                            title="Score in Algorithems"
                            value={"NA"}
                          />
                        </Card>
                      </Col>
                      <Col xs={24} sm={24} md={10} lg={8} xl={8} style={{marginBottom:5}}>
                        <Card bordered={false}>
                          <Statistic title="Overall Score" value={"NA"} />
                        </Card>
                      </Col>
                    </Row>

                    <Card
                      className={styles.tabsCard}
                      bordered={false}
                      tabList={operationTabList}
                      activeTabKey={cptabKey}
                      onTabChange={this.onTabChangeCP}
                    >
                      {this.renderChildrenByTabKey(cptabKey)}
                    </Card>

                    <h1 style={{ marginTop: 50 }}>Projects/Skills/Hackathons/Achievements</h1>

                    <Card
                      className={styles.tabsCard}
                      bordered={false}
                      tabList={projectsTabList}
                      activeTabKey={prtabKey}
                      onTabChange={this.onTabChangePR}
                    >
                      {this.renderChildrenByTabKey(prtabKey)}
                    </Card>

                    <h1 style={{ marginTop: 50 }}>
                      Workshops/Internships/Research Papers
                    </h1>

                    <Card
                      className={styles.tabsCard}
                      bordered={false}
                      tabList={workshopsTabList}
                      activeTabKey={wstabKey}
                      onTabChange={this.onTabChangeWS}
                    >
                      {this.renderChildrenByTabKey(wstabKey)}
                    </Card>

                  </Col>
                </Row>
              </div>
            </>
          ) : null}
        </Skeleton>
      </div>
    );
  }
}

const mapStateToProps = state => {
  

  return {
    auth: state.firebase.auth,
    userProfile: state.auth.userProfile,
    programmingWebsitesProfiles:
      state.auth.userProfile &&
      state.auth.userProfile.programmingWebsitesProfiles
        ? state.auth.userProfile.programmingWebsitesProfiles
        : null,
    skeltonLoading: state.loading
  };
};

const mapDispachToProps = (dispatch, props) => ({
  loadUserProfileData: UID => {
    dispatch(loginActions.loadUserProfileData(UID));
  },
  onUnload: () => dispatch({ type: "HOME_PAGE_UNLOADED" })
});

export default connect(mapStateToProps, mapDispachToProps)(Profile);
